<main class="content">
    <section class="intro">
      <h1 paint="primary" class="font-extrabold">Redeem instant <span paint="warn">discounts</span></h1>
      <p paint="light" class="font-light">Find the best fashion brands, food & drink venues, and more.</p>
      <h3 paint="primary">How to redeem in-store offers</h3>
    </section>
    
    <section class="guide">
      <div>
        <div class="orb" paint="accent">
          <span></span>
          <h1 class="font-extrabold">1</h1>
        </div>
        <p paint="light" class="font-light">
          While in-store, click on the offer you want to use and click on <span bold>Get Code</span>. If the offer is limited to one-time use, click <span>Use Now</span> on the pop-up shown.
        </p>
        <img src="old/how-tos/offer-page.webp" alt="Step 1"/>
      </div>
      <div>
        <div class="orb" paint="primary">
          <span></span>
          <h1 class="font-extrabold">2</h1>
        </div>
        <p paint="light" class="font-light">
          Scan the QR code provided by the merchant, or use the 4-digit pin code number provided by the merchant, to validate the discount.
        </p>
        <img src="old/how-tos/offer-scan.webp" alt="Step 2"/>
      </div>
      <div>
        <div class="orb" paint="warn">
          <span></span>
          <h1 class="font-extrabold">3</h1>
        </div>
        <p paint="light" class="font-light">
          Once validated, show the final code on the black screen to the cashier, who will then apply the discount. Enjoy your savings!
        </p>
        <img src="old/how-tos/offer-redeem.webp" alt="Step 3"/>
      </div>
    </section>

    <section class="outro">
      <p paint="light" class="font-light">For more information, please send us an email on <a href="mailto:support@cloudigo.app" paint="primary">support&#64;cloudigo.app</a> or talk to us on <a target="_top" rel="noreferrer" href="https://www.facebook.com/cloudigo" paint="primary">Facebook</a>.</p>

      <a mat-flat-button class="main" [href]="platform.ANDROID ? 'market://details?id=app.cloudigo.cloudigo' : 'https://play.google.com/store/apps/details?id=app.cloudigo.cloudigo'" target="_blank">Get Android App</a>
      <br/>
      <a mat-stroked-button [href]="platform.IOS ? 'itms-apps://itunes.apple.com/mt/app/cloudigo/id1440612925' : 'https://itunes.apple.com/mt/app/cloudigo/id1440612925'" target="_blank">Get iPhone App</a>
    </section>
</main>